import React, { useState, useEffect, useRef } from 'react';
import './SearchSelect.css';

const SearchSelect = ({
  value,
  onChange,
  options = [],
  placeholder = 'Seleccione una opción...',
  labelKey = 'nombre',
  valueKey = 'id',
  disabled = false,
  onCreateNew = null,
  createNewText = '+ Crear nuevo...',
  loading = false,
  emptyMessage = 'No se encontraron resultados',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);

  // Cerrar el menú al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Hacer focus al input de búsqueda al abrir el dropdown
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
    if (!isOpen) {
      setSearchTerm('');
    }
  }, [isOpen]);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelectOption = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const optionsArray = Array.isArray(options)
    ? options
    : options && Array.isArray(options.results)
    ? options.results
    : [];

  const selectedOption = optionsArray.find(
    (opt) => String(opt[valueKey]) === String(value)
  );

  const filteredOptions = optionsArray.filter((option) => {
    const text = String(option[labelKey] || '').toLowerCase();
    return text.includes(searchTerm.toLowerCase());
  });

  return (
    <div className={`search-select-container ${disabled ? 'disabled' : ''}`} ref={containerRef}>
      <div
        className={`search-select-trigger ${isOpen ? 'open' : ''} ${selectedOption ? 'has-value' : ''}`}
        onClick={toggleDropdown}
      >
        <span className="search-select-value">
          {selectedOption ? selectedOption[labelKey] : placeholder}
        </span>
        <span className="search-select-arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="20"
            height="20"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>

      {isOpen && (
        <div className="search-select-dropdown">
          <div className="search-select-search-wrapper">
            <span className="search-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                width="16"
                height="16"
              >
                <path
                  fillRule="evenodd"
                  d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            <input
              type="text"
              ref={searchInputRef}
              className="search-select-input"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          <div className="search-select-options-list">
            {loading ? (
              <div className="search-select-loading">Cargando...</div>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((option) => {
                const isSelected = String(option[valueKey]) === String(value);
                return (
                  <div
                    key={option[valueKey]}
                    className={`search-select-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => handleSelectOption(option)}
                  >
                    {option[labelKey]}
                  </div>
                );
              })
            ) : (
              <div className="search-select-no-results">{emptyMessage}</div>
            )}
          </div>

          {onCreateNew && (
            <div
              className="search-select-create-action"
              onClick={() => {
                onCreateNew(searchTerm);
                setIsOpen(false);
              }}
            >
              {createNewText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchSelect;
